import { createMayBeForwardRefExpression } from '@angular/compiler';
import { Component, ViewChild, ChangeDetectorRef, AfterViewInit, Optional, Inject, OnDestroy } from '@angular/core';
import { ApiService } from 'app/api.service';
import { FinancialYearService } from 'app/financial-year.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LedgerBookDialogComponent } from 'app/ledger-book-dialog/ledger-book-dialog.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { StatementViewComponent } from 'app/statement-view/statement-view.component';
import { VoucherBreakdownDialogComponent } from 'app/voucher-breakdown-dialog/voucher-breakdown-dialog.component';

@Component({
  selector: 'app-ledger-book',
  templateUrl: './ledger-book.component.html',
  styleUrls: ['./ledger-book.component.scss']
})
export class LedgerBookComponent implements AfterViewInit {
  expandedItem: any;
  expandedNestedItem: any;
  ledgerData: any[] = [];
  startdate: string = '';
  enddate: string = '';
  voucherSearch: string = '';
  search: string = '';
  minDate: string = '';
  maxDate: string = '';
  subscription: any;
  selectedFinancialYears: string[] = [];
  voucherpostingdata = [];
  get_voucher_posting: any[] = [];
  get_voucher_debit: any[] = [];
  get_voucher_credit: any[] = [];
  get_voucher_debits = [];
  voucher_posting_id: number[] = [];
  get_voucher_credits = [];
  narrations: string = '';
  totalCr = [];
  form: boolean = true;
  form1: boolean = true;
  selectedItem: string = "";
  isExpanded: boolean = false;
  selectedLedgers: number[] = [];
  selectedLedgerName: any;
  company_name: any;
  company_address: any;
  hostname: any;
  offset = 0;
  limit = 100;
  loading = false;
  hasMore = true;
  sortColumn: string[] = [];
  sortDirection: string[] = [];
  indexpage: string = '';
  branches: any[] = [];
  branchId: any = null;
  private injectedLedgerOnce = false;


  @ViewChild(CdkVirtualScrollViewport) virtualScroll!: CdkVirtualScrollViewport;
  @ViewChild('closeButton') closeButton: any;
  isModal: boolean = false;
  profitCost_data: any;
  section_data: any[];
  store_data: any[];
  profit_cost_id: any;
  profitcost: any = null;
  store: any = null;
  section: any = null;
  branch: any;

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<LedgerBookComponent>,
    private financialYearService: FinancialYearService
  ) {
    if (this.dialogData) {
      this.isModal = true;
      if (this.dialogData.ledger_id) {
        this.selectedItem = this.dialogData.ledger_id;
      }
    }
  }

  ngOnInit() {
    this.subscription = this.financialYearService.selectedYears$.subscribe(years => {
      this.selectedFinancialYears = years;
      this.setDatesFromFinancialYears(years);
      this.resetDataAndFetch();
    });
    this.fetchData();
    this.hostname = window.location.hostname;
    this.fetchcompany(this.hostname);
    this.fetchBranchData();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setDatesFromFinancialYears(years: string[]) {
    let minYear = Infinity;
    let maxYear = -Infinity;

    years.forEach(yearRange => {
      const parts = yearRange.split('-');
      const start = parseInt(parts[0]);
      const end = parseInt(parts[1]);
      if (start < minYear) minYear = start;
      if (end > maxYear) maxYear = end;
    });

    if (minYear !== Infinity && maxYear !== -Infinity) {
      this.minDate = `${minYear}-04-01`;
      this.maxDate = `${maxYear}-03-31`;

      this.startdate = this.minDate;
      this.enddate = this.maxDate;
    }
  }

  ngAfterViewInit() {
    // Ensure virtual scroll is properly initialized
    if (this.virtualScroll) {
      this.virtualScroll.scrollToIndex(0);
    }
  }

  fetchBranchData(): void {
    this.apiService.getDatabranch().subscribe(
      (response) => {
        this.branches = response;
      },
      (error) => {
        console.error('Error fetching branch data:', error);
      }
    );
  }

  fetchData() {
    if (!this.hasMore || this.loading) return;
    
    this.loading = true;
    this.indexpage = "ledgerbook";
    console.log('Fetching data with offset:', this.offset, 'limit:', this.limit);

    const sorting = this.sortColumn
      .map((column, index) => `${column}:${this.sortDirection[index]}`)
      .join(',');

    // Build filters object
    const filters: any = {};
    if (this.startdate) {
      filters.from_date = this.startdate;
    }
    if (this.enddate) {
      filters.to_date = this.enddate;
    }
    if (this.branchId) {
      filters.branch_id = this.branchId;
    }
    if (this.profitcost) {
      filters.profit_cost_id = this.profitcost;
    }
    if (this.section) {
      filters.section_id = this.section;
    }
    if (this.store) {
      filters.store_id = this.store;
    }

    this.apiService.getDataLedger(filters, 1, this.limit, this.offset, sorting, '', this.indexpage, false).subscribe(
      (response) => {
        console.log('API Response:', response);

        // For virtual scrolling, we need to handle data differently
        if (this.offset === 0) {
          // First load or filter change - replace data
          this.ledgerData = [...response.ledger_data];
        } else {
          // Infinite scroll - append data
          this.ledgerData = [...this.ledgerData, ...response.ledger_data];
        }

        const normalizedData = (response.ledger_data || []).map((l: any) => ({
          ...l,
          ledger_id: l.ledger_id ?? l.id
        }));

        const isFirstLoad = (this.offset === 0);
        const targetId = this.isModal ? this.dialogData?.ledger_id : null;
        let batch = normalizedData;
        if (targetId) {
          // Filter out the target from every batch to prevent duplicates in the list
          batch = batch.filter(l => (l.ledger_id != targetId && l.id != targetId));
        }

        if (isFirstLoad) {
          if (targetId && !this.injectedLedgerOnce) {
            const targetInFirstBatch = normalizedData.find(l => (l.ledger_id == targetId || l.id == targetId));
            if (targetInFirstBatch) {
              // Found in first 100, pin to top
              this.ledgerData = [targetInFirstBatch, ...batch];
              this.expandAndScrollToLedger(0);
              this.injectedLedgerOnce = true;
            } else {
              // Not in first batch - check if it exists in ALL ledger book data
              // 1. Show the initial batch immediately so the list isn't empty
              this.ledgerData = [...batch];
              this.cdr.detectChanges();
              // 2. Load ALL ledger book data with same filters to check if target exists
              this.apiService.getDataLedger(filters, 1, 10000000, 0, sorting, '', this.indexpage, true).subscribe(
                (allDataResponse: any) => {
                  const allLedgers = (allDataResponse.ledger_data || []).map((l: any) => ({
                    ...l,
                    ledger_id: l.ledger_id ?? l.id
                  }));
                  // Check if target ledger exists in the complete ledger book dataset
                  const targetLedger = allLedgers.find((l: any) => (l.ledger_id == targetId || l.id == targetId));
                  if (targetLedger) {
                    //  Ledger EXISTS in ledger book data - pin it to top
                    const normalizedLedger = {
                      ...targetLedger,
                      ledger_id: targetLedger.ledger_id ?? targetLedger.id
                    };
                    // Prepend to existing list and de-duplicate
                    this.ledgerData = [normalizedLedger, ...this.ledgerData.filter(l => (l.ledger_id != targetId && l.id != targetId))];
                    this.expandAndScrollToLedger(0);
                    this.injectedLedgerOnce = true;
                    this.cdr.detectChanges();
                  } else {
                    console.log('Target ledger not found in Ledger Book data - not showing');
                    this.injectedLedgerOnce = true;
                  }
                },
                (error) => {
                  console.error('Error loading all ledger book data:', error);
                  this.injectedLedgerOnce = true;
                }
              );
            }
          } else {
            this.ledgerData = [...normalizedData];
          }
        } else {
          // Normal scroll load - append the filtered batch
          this.ledgerData = [...this.ledgerData, ...batch];
        }
        
        this.offset = response.next_offset;
        this.hasMore = response.ledger_data.length >= this.limit;
        
        console.log('Updated ledgerData length:', this.ledgerData.length);
        console.log('HasMore:', this.hasMore);
        console.log('Next offset:', this.offset);

        this.form = this.ledgerData.length > 0;
        this.form1 = !this.form;
        this.loading = false;

        // Trigger change detection for virtual scrolling
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching data:', error);
        this.loading = false;
        this.hasMore = false;
        this.cdr.detectChanges();
      }
    );
  }

  onScrollIndexChange(index: number) {
    if (!this.virtualScroll) return;
    
    // Load more data when user scrolls near the end
    const endIndex = this.virtualScroll.getRenderedRange().end;
    const totalItems = this.ledgerData.length;
    
    // Load more when user is within 10 items of the end
    if (endIndex >= totalItems - 10 && this.hasMore && !this.loading) {
      console.log('Loading more data via virtual scroll...');
      this.fetchData();
    }
  }

  // Enhanced track by function
  trackByFn(index: number, item: any): any {
    return item.id || item.ledger_id || index;
  }

  // Get actual index for display
  getActualIndex(virtualIndex: number): number {
    const viewport = this.virtualScroll;
    if (viewport) {
      return viewport.getRenderedRange().start + virtualIndex + 1;
    }
    return virtualIndex + 1;
  }

  toggleNestedTables(voucher: any) {
    this.fetchVoucherData(voucher.voucher_posting_id);
  }

  toggleRow(item: any) {
    if (!item.voucherpostingdata) {
      this.fetchVoucherDetails(item?.id);
    }
    if (this.selectedItem && this.selectedItem === item.id) {
      this.selectedItem = "";
    } else {
      this.selectedItem = item.id;
      this.selectedLedgerName = item.ledger_name;
    }
  }

  fetchVoucherDetails(ledgerId: number) {
    // Note: getVoucherData may need to be updated to accept branch_id if needed
    this.apiService.getVoucherData(ledgerId, this.startdate, this.enddate).subscribe(
      (response) => {
        this.voucherpostingdata = response.data;
        console.log('voucherposting data', this.voucherpostingdata);
        
        if (this.ledgerData.length >= 1) {
          this.form = true;
          this.form1 = false;
        } else {
          this.form = false;
          this.form1 = true;
        }
      },
      (error) => {
        console.error('Error fetching voucher data:', error);
      }
    );
  }

  toggleNestedTable(voucher_posting_id: number) {
    if (this.expandedNestedItem && this.expandedNestedItem !== voucher_posting_id) {
      this.expandedNestedItem.showNestedTables = false;
      this.expandedNestedItem = null;
      this.fetchVoucherData(voucher_posting_id);
    } else {
      if (voucher_posting_id !== undefined) {
        this.fetchVoucherData(voucher_posting_id);
      }
    }
  }

  showParticularledger(voucher: any) {
    if (!voucher || !this.get_voucher_debits || !this.get_voucher_credits) {
      return;
    }
    let selectedLedger = this.selectedLedgerName;
    let isDebitSide = this.get_voucher_debits.some(debit => debit.ledger_name === selectedLedger);
    let correspondingLedger = isDebitSide ? this.get_voucher_credits.find(credit => credit.ledger_name !== selectedLedger)
      : this.get_voucher_debits.find(debit => debit.ledger_name !== selectedLedger);

    if (correspondingLedger) {
      voucher.particular = {
        ledger_name: correspondingLedger.ledger_name,
        amount: correspondingLedger.amount
      };
    } else {
      voucher.particular = { ledger_name: "N/A", amount: 0 };
    }

    console.log("Updated Particular ledger:", voucher.particular);
  }

  fetchVoucherData(voucher_posting_id: number) {
    this.apiService.getVoucherdetails(voucher_posting_id).subscribe(
      (response) => {
        this.get_voucher_debits = response.get_voucher_debit;
        this.get_voucher_credits = response.get_voucher_credit;
        const selectedVoucher = this.voucherpostingdata.find(v => v.voucher_posting_id === voucher_posting_id);
        this.ledgerbookdetailsModal(selectedVoucher);
      },
      (error) => {
        console.error('Error fetching voucher data:', error);
      }
    );
  }

  fetchcompany(data: any) {
    this.apiService.Companydetails(data).subscribe(
      (response) => {
        console.log('company_details', response);
        this.company_name = response.name;
        this.company_address = response.address;
        console.log(this.company_name, this.company_address);
      },
      (error) => {
        console.error('Error fetching company data:', error);
      }
    );
  }

  ledgerbookdetailsModal(voucher: any) {
    this.dialog.open(LedgerBookDialogComponent, {
      width: '800px',
      disableClose: true,
      data: {
        voucher_name: voucher?.voucher_name,
        voucher_no: voucher?.voucher_no,
        date: voucher?.date,
        narration: voucher?.narration,
        debits: this.get_voucher_debits,
        credits: this.get_voucher_credits,
        company_name: this.company_name,
        company_address: this.company_address,
        creation_voucher_id: voucher?.creation_voucher_id || voucher?.voucher_posting_id
      }
    });
  }

  isItemExpanded(item: any): boolean {
    return this.expandedItem === item;
  }

  isNestedItemExpanded(item: any): boolean {
    return this.expandedNestedItem === item;
  }

  toggleSelection(ledgerId: number, event: any) {
    if (event.target.checked) {
      if (!this.selectedLedgers.includes(ledgerId)) {
        this.selectedLedgers.push(ledgerId);
        console.log(`Fetching data for ledger ID: ${ledgerId}`);
        this.fetchVoucherDetails(ledgerId);
      }
    } else {
      this.selectedLedgers = this.selectedLedgers.filter(id => id !== ledgerId);
      this.voucherpostingdata = this.voucherpostingdata.filter(item => item.ledger_id !== ledgerId);
    }
    console.log('Selected Ledgers:', this.selectedLedgers);
  }

  export(format: string) {
    if (format === 'excel') {
      this.exportToExcel();
    } else if (format === 'pdf') {
      this.convertToPdf();
    } else {
      console.error('Unsupported format. Please choose either "excel" or "pdf".');
    }
  }

  exportToExcel() {
    if (this.selectedLedgers.length === 0) {
      alert("Please select at least one ledger!");
      return;
    }
    console.log("Selected Ledgers:", this.selectedLedgers);

    const selectedVoucherData = this.voucherpostingdata.filter(transaction =>
      this.selectedLedgers.includes(Number(transaction.ledger_id))
    );

    if (selectedVoucherData.length === 0) {
      alert("No data available for selected ledger(s)!");
      return;
    }

    const exportData = selectedVoucherData.map(transaction => ({
      date: transaction.date,
      ledgerId: transaction.ledger_id,
      narration: transaction.narration,
      totalCr: transaction.total_cr,
      totalDr: transaction.total_dr,
      voucherId: transaction.voucher_id,
      voucherName: transaction.voucher_name,
      voucherNo: transaction.voucher_no
    }));

    const payload = {
      exportType: 'excel',
      expanded: true,
      data: exportData,
      ledgerIds: this.selectedLedgers,
    };
    console.log('Sending payload:', payload);

    this.apiService.sendledgerBookexport(payload).subscribe(response => {
      console.log("Export Response:", response);

      if (response && response.file_url) {
        const downloadLink = document.createElement('a');
        downloadLink.href = response.file_url;
        downloadLink.download = 'LedgerBook_Report.xlsx';
        downloadLink.target = '_blank';

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        alert("Error: File URL not received!");
      }
    }, error => {
      console.error('Error sending data:', error);
    });
  }

  convertToPdf() {
    if (this.selectedLedgers.length === 0) {
      alert("Please select at least one ledger!");
      return;
    }
    console.log("Selected Ledgers:", this.selectedLedgers);
    const selectedVoucherData = this.voucherpostingdata.filter(transaction =>
      this.selectedLedgers.includes(Number(transaction.ledger_id))
    );

    if (selectedVoucherData.length === 0) {
      alert("No data available for selected ledger(s)!");
      return;
    }

    const exportData = selectedVoucherData.map(transaction => ({
      date: transaction.date,
      ledgerId: transaction.ledger_id,
      narration: transaction.narration,
      totalCr: transaction.total_cr,
      totalDr: transaction.total_dr,
      voucherId: transaction.voucher_id,
      voucherName: transaction.voucher_name,
      voucherNo: transaction.voucher_no
    }));

    const payload = {
      exportType: 'pdf',
      expanded: true,
      data: exportData,
      ledgerIds: this.selectedLedgers,
    };

    console.log('Sending payload:', payload);
    this.apiService.sendledgerBookexport(payload).subscribe(response => {
      console.log("Export Response:", response);

      if (response && response.file_url) {
        const downloadLink = document.createElement('a');
        downloadLink.href = response.file_url;
        downloadLink.download = 'LedgerBook_Report.pdf';
        downloadLink.target = '_blank';

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        alert("Error: File URL not received!");
      }
    }, error => {
      console.error('Error sending data:', error);
    });
  }

  calculateClosingBalanceAndSide(ledger: any): string {
    const openingBalance = parseFloat(ledger.opening_balance || 0);
    const openingSide = ledger.opening_balance_side;
    const totalDebit = parseFloat(ledger.total_dr_amount || 0);
    const totalCredit = parseFloat(ledger.total_cr_amount || 0);

    let closingBalance: number;
    let closingSide: string;

    if (openingSide === 'Dr') {
      closingBalance = (openingBalance + totalDebit) > totalCredit ? (openingBalance + totalDebit) - totalCredit : totalCredit - (openingBalance + totalDebit);
      closingSide = (openingBalance + totalDebit) > totalCredit ? 'Dr' : 'Cr';
    } else {
      closingBalance = (openingBalance + totalCredit) > totalDebit ? (openingBalance + totalCredit) - totalDebit : totalDebit - (openingBalance + totalCredit);
      closingSide = (openingBalance + totalCredit) > totalDebit ? 'Cr' : 'Dr';
    }

    return closingBalance === 0 ? `0.00 ${closingSide}` : `${Math.abs(closingBalance).toFixed(2)} ${closingSide}`;
  }

  calculateOpeningBalanceAndSide(ledger: any): { balance: number, side: string } {
    let totalCrOpeningBalance = 0;
    let totalDrOpeningBalance = 0;

    if (ledger.get_ledger_opening_balance) {
      const openingBalance = parseFloat(ledger.get_ledger_opening_balance.opening_balance || 0);
      const openingSide = ledger.get_ledger_opening_balance.side;

      if (openingSide === 'Cr') {
        totalCrOpeningBalance += openingBalance;
      } else {
        totalDrOpeningBalance += openingBalance;
      }
    }
    const balance = totalCrOpeningBalance - totalDrOpeningBalance;
    const side = totalCrOpeningBalance > totalDrOpeningBalance ? 'Cr' : 'Dr';
    return { balance: Math.abs(balance), side };
  }

  getBranchId(item: any): string {
    if (!item) {
      return '';
    }
    const branchId = item.branch_id || item.branch?.id || item.get_ledger_opening_balance?.branch_id;
    return branchId ? branchId.toString() : '';
  }

  // getBranchDisplayName(item: any): string {
  //   if (!item) {
  //     return '';
  //   }
  //   const branchId = item.branch_id || item.branch?.id || item.get_ledger_opening_balance?.branch_id;
  //   if (branchId) {
  //     const branch = this.branches.find((b: any) => b.id === branchId);
  //     if (branch?.name) {
  //       return branch.name;
  //     }
  //   }
  //   return '';
  // }

  sortData(column: string): void {
    const columnIndex = this.sortColumn.indexOf(column);

    if (columnIndex !== -1) {
      this.sortDirection[columnIndex] = this.sortDirection[columnIndex] === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn.push(column);
      this.sortDirection.push('asc');
    }
    this.resetDataAndFetch();
  }

  getSortDirection(column: string): string {
    const index = this.sortColumn.indexOf(column);
    return index !== -1 ? this.sortDirection[index] : '';
  }

  onSearch(): void {
    this.resetDataAndFetch();
  }

  resetFilters() {
    this.sortColumn = [];
    this.sortDirection = [];
    this.startdate = '';
    this.enddate = '';
    this.branchId = null;
    this.profitcost = null;
    this.section = null;
    this.store = null;
    this.resetDataAndFetch();
  }

  fetchAllData(): void {
    this.loading = true;
    this.indexpage = "ledgerbook";
    
    if (this.virtualScroll) {
      setTimeout(() => {
        this.virtualScroll.scrollToIndex(this.ledgerData.length - 1);
      }, 100);
    }
    
    const sorting = this.sortColumn
      .map((column, index) => `${column}:${this.sortDirection[index]}`)
      .join(',');

    // Build filters object
    const filters: any = {};
    if (this.startdate) {
      filters.from_date = this.startdate;
    }
    if (this.enddate) {
      filters.to_date = this.enddate;
    }
    if (this.branchId) {
      filters.branch_id = this.branchId;
    }
    if (this.profitcost) {
      filters.profit_cost_id = this.profitcost;
    }
    if (this.section) {
      filters.section_id = this.section;
    }
    if (this.store) {
      filters.store_id = this.store;
    }

    this.apiService.getDataLedger(filters, 1, 10000000, 0, sorting, '', this.indexpage, true).subscribe(
      (response) => {
        this.ledgerData = response.ledger_data || [];
        this.loading = false;
        this.hasMore = false; // No more data to fetch
        this.offset = response.ledger_data.length; // Update offset
        
        this.form = this.ledgerData.length > 0;
        this.form1 = !this.form;
        
        console.log('All data fetched successfully:', this.ledgerData.length);
        
        // Trigger change detection
        this.cdr.detectChanges();
      },
      (error) => {
        this.loading = false;
        console.error('Error fetching all data:', error);
      }
    );
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  openStatementViewModal(ledgerId: any) {
    this.dialog.open(StatementViewComponent, {
      width: '95vw',
      height: '95vh',
      maxWidth: '100vw',
      data: {
        ledger_id: ledgerId,
        is_modal: true
      },
      panelClass: 'custom-modal-box'
    });
  }

  resetDataAndFetch() {
    this.ledgerData = [];
    this.offset = 0;
    this.hasMore = true;
    this.loading = false;
    this.selectedItem = "";
    this.selectedLedgers = [];
    this.voucherpostingdata = [];
    this.fetchData();
    
    // Scroll to top after reset
    if (this.virtualScroll) {
      setTimeout(() => {
        this.virtualScroll.scrollToIndex(0);
      }, 100);
    }
  }

  private expandAndScrollToLedger(index: number) {
    setTimeout(() => {
      if (this.virtualScroll) {
        this.virtualScroll.scrollToIndex(index, 'smooth');
      }
      const ledger = this.ledgerData[index];
      if (ledger) {
        this.selectedItem = ledger.ledger_id || ledger.id;
        this.selectedLedgerName = ledger.ledger_name;
        this.fetchVoucherDetails(ledger.ledger_id || ledger.id);
        this.cdr.detectChanges();
      }
    }, 300);
  }
  onBranchChange(branchId: any) {
    if (branchId) {
      this.branchId = branchId;
      this.fetchProfitCost(branchId);
    } else {
      this.branchId = null;
      this.profitCost_data = [];
    }

    // reset dependents
    this.profitcost = null;
    this.section = null;
    this.store = null;
    this.section_data = [];
    this.store_data = [];
  }


  fetchProfitCost(branch_id: any) {
    const postData = {
      branch_id: branch_id
    };
    this.apiService.getProfitCostByBranch(postData).subscribe(
      (response) => {
        this.profitCost_data = response;
        console.log('profit center', this.profitCost_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }


  onProfitCostChange(profitCostId: any) {
    if (!profitCostId) {
      this.section_data = [];
      this.store_data = [];
      return;
    }
    this.profit_cost_id = profitCostId;
    this.fetchSection(profitCostId);
    this.fetchStoreData(profitCostId);
  }

  fetchSection(profit_id: any) {
    this.apiService.getSectionByProfitCost(profit_id).subscribe(
      (response) => {
        this.section_data = response;
        console.log('Section data loaded:', this.section_data);
      },
      (error) => {
        console.error('Error fetching sections with GET, trying POST:', error);
      }
    );
  }

  fetchStoreData(profitCostId: number) {
    const postData = { profit_cost_id: profitCostId };
    this.apiService.getStoreByPcCc(postData).subscribe(
      (response) => {
        this.store_data = response;
      },
      (error) => console.error(error)
    );
  }

  openVoucherBreakdown(item: any) {
    this.dialog.open(VoucherBreakdownDialogComponent, {
      width: '1200px',
      height: '600px',
      disableClose: true,
      data: {
        ledger_id: item.ledger_id || item.id,
        ledger_name: item.ledger_name,
        branch_id: this.branchId,
        from_date: this.startdate,
        to_date: this.enddate
      }
    });
  }

}